import { ImportantRemark } from './important-remark';
import { OnSiteChecking } from './onsite-checking';
import { PackingMarking } from './packing-marking';
import { ProductDescription } from './product-description';
import { QuantityAvailable } from './quantity-available';
import { Workmanship } from './workmanship';

type ItemType =
  | 'quantityAvailable'
  | 'productDescriptionStyleColor'
  | 'workmanship'
  | 'onSiteTest'
  | 'packingMarking'
  | 'importantRemarksAttachments';

export const ElementCriteria = {
  quantityAvailable: QuantityAvailable,
  productDescriptionStyleColor: ProductDescription,
  workmanship: Workmanship,
  onSiteTest: OnSiteChecking,
  packingMarking: PackingMarking,
  importantRemarksAttachments: ImportantRemark
};
